import React from 'react'
import { Link } from 'react-router-dom'
import { of } from 'rxjs'
import { Icon, makeStyles, useObservable } from '@cicero/ui'
import { PageDoc, PageSchema, useModel } from '../models'

export const PageLinkRenderer = ({ id }: { id?: string }) => {
  const Pages = useModel(PageSchema)
  const page = useObservable(() => id ? Pages.GET$(id) : of(null), null, [id])
  return page ? <PageLink page={page} /> : <span>-</span>
}

export const PageLink = ({ page, icon, quickOpen }: { page: PageDoc, icon?: boolean, quickOpen?: boolean }) => {
  const { link, linkIcon } = pageLinkStyles()
  const Pages = useModel(PageSchema)

  return <Link
    className={link}
    to={PageSchema.getPageLink(page)}
    onClick={(ev) => {
      if (quickOpen) {
        ev.preventDefault()
        Pages.active$.next(page)
      }
    }}
  >
    { icon && page.icon ? <Icon className={linkIcon}>{page.icon}</Icon> : null }
    {page.title}
  </Link>
}

const pageLinkStyles = makeStyles({
  link: {
    color: '#333',
    textDecoration: 'none',
    borderBottom: '1px #DDD dashed',
    transition: 'all ease-in-out .2s',

    '&:hover': {
      borderBottom: '1px #AAA dashed',
    },
  },
  linkIcon: {
    color: '#666',
    fontSize: 12,
    marginRight: 6,
  },
})
